/**
 * Wishlist-ready architecture for the shared product card + header icon.
 * Persists to localStorage so the heart toggle is genuinely functional today;
 * swap `readIds`/`saveIds` for an API call later to back it with an app/account
 * without touching any markup — every card already carries data-product-id.
 * Dispatches `wifi:wishlist:change` on `document` with { productId, active, count }
 * so other UI (a wishlist counter, a wishlist page) can react.
 */
const STORAGE_KEY = 'wifi:wishlist';

function readIds() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch (error) {
    return [];
  }
}

function saveIds(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function paintButton(button, active) {
  button.setAttribute('aria-pressed', String(active));
}

function paintCount(count) {
  document.querySelectorAll('[data-wifi-wishlist-count-value]').forEach((el) => {
    el.textContent = String(count);
    el.hidden = count === 0;
  });
}

function initButtons(root = document) {
  const ids = readIds();
  root.querySelectorAll('[data-wifi-wishlist-toggle]').forEach((button) => {
    paintButton(button, ids.includes(button.dataset.productId));
  });
  paintCount(ids.length);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wifi-wishlist-toggle]');
  if (!button) return;

  event.preventDefault();
  const productId = button.dataset.productId;
  const ids = readIds();
  const index = ids.indexOf(productId);
  const active = index === -1;

  if (active) {
    ids.push(productId);
  } else {
    ids.splice(index, 1);
  }

  saveIds(ids);
  document
    .querySelectorAll(`[data-wifi-wishlist-toggle][data-product-id="${productId}"]`)
    .forEach((match) => paintButton(match, active));
  paintCount(ids.length);

  document.dispatchEvent(
    new CustomEvent('wifi:wishlist:change', { detail: { productId, active, count: ids.length } })
  );
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initButtons());
} else {
  initButtons();
}
